import "./faq.css";
